import React from "react";
import moment from "moment";
import Badge from "Utils/Badge/Badge";

const FORMATO_FECHA_HORA = "DD/MM/YYYY HH:mm";

export const HistorialDesfaseTable = ({ historial }) => {
    const { cambios } = historial;

    return (
        <div className="new-table-wrapper mt-3">
            <table className="table-striped">
                <thead>
                    <tr>
                        <th>Fecha y hora del cambio</th>
                        <th>Fecha y hora configurada</th>
                        <th>Tipo</th>
                        <th>Usuario</th>
                    </tr>
                </thead>
                <tbody>
                    {cambios.length === 0 && (
                        <tr>
                            <td colSpan={4} className="text-center">
                                No hay cambios registrados en este reloj
                            </td>
                        </tr>
                    )}
                    {cambios.map((cambio) => (
                        <tr key={cambio.id}>
                            <td className="text-center text-nowrap">
                                {moment(cambio.fecha_creacion).format(
                                    FORMATO_FECHA_HORA,
                                )}
                            </td>
                            <td className="text-center text-nowrap">
                                {moment(cambio.fecha_hora_configurada).format(
                                    FORMATO_FECHA_HORA,
                                )}
                            </td>
                            <td className="text-center">
                                {cambio.es_tiempo_actual ? (
                                    <Badge text="Actual" variant="success" />
                                ) : (
                                    <Badge text="Manual" variant="warning" />
                                )}
                            </td>
                            <td className="text-center">
                                {cambio.usuario_nombre || "N/A"}
                            </td>
                        </tr>
                    ))}
                </tbody>
            </table>
        </div>
    );
};
